import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden bg-white" data-id="element-170">
      <div className="container mx-auto px-6 md:px-12" data-id="element-171">
        {/* Mobile Headline (visible only on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="md:hidden mb-8" data-id="element-172">
          <h1 className="font-heading text-5xl leading-tight text-dark" data-id="element-173">
            Бездоганний стиль, <br data-id="element-174" />
            що підкреслює вашу красу
          </h1>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-175">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-xl z-10 order-2 md:order-1" data-id="element-176">
            {/* Desktop Headline (hidden on mobile) */}
            <h1 className="hidden md:block font-heading text-5xl md:text-6xl lg:text-7xl leading-tight text-dark mb-6" data-id="element-177">
              Бездоганний стиль, <br data-id="element-178" />
              що підкреслює вашу красу
            </h1>
            <p className="text-gray-600 text-lg md:text-xl mb-10 font-normal leading-relaxed" data-id="element-179">
              Повний спектр послуг: від стрижок та складного фарбування до
              манікюру та догляду.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-180">
              <a href="#contact" className="px-8 py-4 bg-dark text-white text-center text-sm font-medium tracking-wide hover:bg-black transition-colors" data-id="element-181">
                Записатися на послугу
              </a>
              <a href="#courses" className="px-8 py-4 border border-dark text-dark text-center text-sm font-medium tracking-wide hover:bg-gray-50 transition-colors" data-id="element-182">
                Дізнатися про курси
              </a>
            </div>

            <div className="grid grid-cols-3 gap-6 border-t border-gray-100 pt-8" data-id="element-183">
              <div data-id="element-184">
                <p className="font-heading text-4xl text-accent mb-1" data-id="element-185">12+</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-186">
                  Років досвіду
                </p>
              </div>
              <div data-id="element-187">
                <p className="font-heading text-4xl text-accent mb-1" data-id="element-188">5k+</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-189">
                  Задоволених клієнтів
                </p>
              </div>
              <div data-id="element-190">
                <p className="font-heading text-4xl text-accent mb-1" data-id="element-191">300+</p>
                <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-192">
                  Випускників курсів
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative h-[400px] md:h-[800px] w-full order-1 md:order-2" data-id="element-193">
            <div className="absolute inset-0 bg-[#F9F9F9] rounded-tl-[60px] rounded-br-[60px] md:rounded-tl-[100px] md:rounded-br-[100px] overflow-hidden flex items-center justify-center border border-gray-100" data-id="element-194">
              <div className="text-center" data-id="element-195">
                <div className="w-16 h-16 mx-auto mb-4 border border-gray-200 rounded-full flex items-center justify-center" data-id="element-196">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-197">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-198"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5" data-id="element-199"></circle>
                    <polyline points="21 15 16 10 5 21" data-id="element-200"></polyline>
                  </svg>
                </div>
                <p className="text-sm text-gray-400 font-light tracking-widest uppercase" data-id="element-201">
                  Місце для фото
                </p>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-accent rounded-full opacity-50" data-id="element-202"></div>
            <div className="absolute -top-6 -right-6 w-24 h-24 border border-gray-300 rounded-full opacity-50" data-id="element-203"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}